import { render } from "./NavigationLink.vue?vue&type=template&id=2e6eeade"
import script from "./NavigationLink.vue?vue&type=script&lang=js"
export * from "./NavigationLink.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__